import { render, staticRenderFns } from "./tit-secondary.vue?vue&type=template&id=559fc5fc&scoped=true&"
import script from "./tit-secondary.vue?vue&type=script&lang=js&"
export * from "./tit-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559fc5fc",
  null
  
)

export default component.exports